import {Combobox} from '@mantine/core';
import classes from './combobox.module.css';

export const ComboboxTheme = Combobox.extend({
  classNames: classes,
});